import {Modal} from '@mantine/core';
import type {
  InputMethod,
  InputMethodItem,
} from '../../../../constants/inputMethods';
import {Z_INDEX} from '../../../../constants/zIndex';
import {ModalCancelButton} from '../ModalCancelButton';
import {InputMethodButton} from './InputMethodButton';

type Props = {
  opened: boolean;
  onClose: () => void;
  methods: readonly InputMethodItem[];
  onSelectMethod: (method: InputMethod) => void;
  onBack: () => void;
  isAddingEntryManagement?: boolean;
};

const MODAL_RADIUS = 16;
const MODAL_SIZE = 'md';

export const InputMethodSelectionModal: React.FC<Props> = ({
  opened,
  onClose,
  methods,
  onSelectMethod,
  onBack,
  isAddingEntryManagement = false,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      radius={MODAL_RADIUS}
      centered
      size={MODAL_SIZE}
      zIndex={Z_INDEX.MODAL}
      title={
        isAddingEntryManagement
          ? '未登録企業の選考予定を追加'
          : '選考予定を追加'
      }
      styles={{
        title: {
          fontWeight: 'bold',
        },
      }}
    >
      <div className="flex flex-col gap-24">
        <div className="flex flex-col gap-16">
          {methods.map((method) => (
            <InputMethodButton
              key={method.id}
              title={method.title}
              description={method.description}
              icon={method.icon}
              onClick={() => onSelectMethod(method.id)}
            />
          ))}
        </div>

        <div className="flex items-center justify-center w-full">
          <ModalCancelButton onClick={onBack}>キャンセル</ModalCancelButton>
        </div>
      </div>
    </Modal>
  );
};
